import React from "react";
import { format } from "date-fns";
import { FaEdit, FaUndo } from "react-icons/fa";

const ProgramManagerInventoryTable = ({ inventory, onReportUsage, onReturnItems }) => {

    const calculateRemaining = (item) => {
        return item.quantityIssued - (item.quantityConsumed || 0) - (item.quantityReturned || 0);
    };

    return (
        <div className="bg-white rounded-lg shadow p-6">
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm">
                    <thead>
                        <tr className="bg-orange-100 text-gray-600 text-left">
                            <th className="px-4 py-2">Item Name</th>
                            <th className="px-4 py-2">Project</th>
                            <th className="px-4 py-2">Quantity Issued</th>
                            <th className="px-4 py-2">Quantity Consumed</th>
                            <th className="px-4 py-2">Quantity Returned</th>
                            <th className="px-4 py-2">Remaining</th>
                            <th className="px-4 py-2">Vendor</th>
                            <th className="px-4 py-2">Date Issued</th>
                            <th className="px-4 py-2 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {inventory.length === 0 ? (
                            <tr>
                                <td colSpan="9" className="text-center text-gray-500 py-4">
                                    No inventory items found for your projects.
                                </td>
                            </tr>
                        ) : (
                            inventory.map(item => {
                                const remaining = calculateRemaining(item);
                                const isLowStock = remaining < 5;

                                return (
                                    <tr key={item._id} className={`border-b hover:bg-gray-50 ${isLowStock ? 'bg-red-50' : ''}`}>
                                        <td className="px-4 py-2 font-medium">{item.itemName || item.itemId?.name || 'N/A'}</td>
                                        <td className="px-4 py-2 text-gray-600">{item.issuedToProject?.projectTitle || 'N/A'}</td>
                                        <td className="px-4 py-2">{item.quantityIssued} {item.itemId?.unitOfMeasure || ''}</td>
                                        <td className="px-4 py-2">{item.quantityConsumed || 0} {item.itemId?.unitOfMeasure || ''}</td>
                                        <td className="px-4 py-2">{item.quantityReturned || 0} {item.itemId?.unitOfMeasure || ''}</td>
                                        <td className={`px-4 py-2 font-semibold ${isLowStock ? 'text-red-600' : 'text-gray-700'}`}>
                                            {remaining} {item.itemId?.unitOfMeasure || ''}
                                        </td>
                                        <td className="px-4 py-2 text-gray-600">{item.vendorName || 'N/A'}</td>
                                        <td className="px-4 py-2 text-gray-600">
                                            {item.issueDate
                                                ? format(new Date(item.issueDate), "dd-MMM-yyyy")
                                                : item.issuedAt
                                                    ? format(new Date(item.issuedAt), "dd-MMM-yyyy")
                                                    : 'N/A'}
                                        </td>
                                        <td className="px-4 py-2 text-right">
                                            <button
                                                onClick={() => onReportUsage(item)}
                                                className="text-blue-600 hover:text-blue-800 mr-3"
                                                title="Report Usage"
                                            >
                                                <FaEdit />
                                            </button>
                                            <button
                                                onClick={() => onReturnItems(item)}
                                                className="text-purple-600 hover:text-purple-800"
                                                title="Return Items"
                                            >
                                                <FaUndo />
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProgramManagerInventoryTable;
